import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ component: Component, ...rest }) => {
	const isLoggedIn = useSelector(state => state.isLoggedIn);
	const [state, setState] = useState(null);
	const [waiting, setWaiting] = useState(true);
	const componentToRender = props => (isLoggedIn ? <Component {...rest} {...props} /> : <Redirect to="/" />);

	useEffect(() => setState(isLoggedIn), [isLoggedIn]);
	useEffect(() => {
		if (state !== null) {
			setWaiting(false);
		}
	}, [state]);

	if (waiting) {
		return <></>;
	}

	return (
		<Route
			{...rest}
			render={props => {
				return componentToRender(props);
			}}
		/>
	);
};

export default ProtectedRoute;
